import { ButtonHTMLAttributes, ReactNode } from "react";

type Variant = "primary" | "secondary" | "danger" | "ghost";
type Size = "sm" | "md";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
  children: ReactNode;
  isLoading?: boolean;
}

const variantMap: Record<Variant, string> = {
  primary: "btn-base btn-primary",
  secondary: "btn-base btn-secondary",
  danger: "btn-base btn-danger",
  ghost: "btn-base btn-ghost",
};

export function Button({
  variant = "primary",
  size = "md",
  children,
  isLoading,
  disabled,
  className = "",
  ...props
}: ButtonProps) {
  const classes = [variantMap[variant], size === "sm" ? "btn-sm" : "", className]
    .filter(Boolean)
    .join(" ");

  return (
    <button className={classes} disabled={disabled || isLoading} {...props}>
      {isLoading && (
        <span className="inline-block h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent" />
      )}
      {children}
    </button>
  );
}
